import { createFileRoute } from '@tanstack/react-router';
import { UserFieldsTable } from '../../pages/platform/tenants/user-fields/UserFieldsTable';

// Pestaña Campos del drill-down (catálogo de campos personalizados de usuario del tenant). El
// tenantId sale del PATH (no del user logueado) y se pasa por prop a la tabla, que consume
// tenantApi.*UserField contra `/tenants/{tid}/user-fields`. El acceso ya está gateado por
// `platform.tenant.userfields.manage` (scope PLATFORM) en el sub-nav del shell ($tenantId.tsx); los
// botones de crear/editar/eliminar/deshabilitar repiten el Gate adentro. El backend re-enforza.
export const Route = createFileRoute(
    '/_authenticated/_layout/platform/tenants/$tenantId/user-fields',
)({
    component: TenantUserFields,
});

function TenantUserFields() {
    const { tenantId } = Route.useParams();
    return <UserFieldsTable tenantId={tenantId} />;
}
